var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isUserEmployee || _vm.isUserEmployer ? _c('div', [_vm.value.isGranted === null ? [_vm.isIncoming ? [_c('v-btn', {
    attrs: {
      "small": "",
      "width": "100",
      "color": "secondary lighten-5"
    }
  }, [_c('span', {
    staticClass: "secondary--text"
  }, [_vm._v(" 면접요청중 ")])])] : _vm._e(), _vm.isOutgoing ? [_c('v-btn', {
    attrs: {
      "small": "",
      "width": "100",
      "color": "primary lighten-5"
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v(" 면접요청중 ")])])] : _vm._e()] : _vm._e(), _vm.value.isGranted == true ? [_vm.isOnline ? [_c('v-btn', {
    attrs: {
      "small": "",
      "width": "100",
      "color": "lightblue lighten-5",
      "href": `/interview/${_vm.value.interview}`
    }
  }, [_c('span', {
    staticClass: "lightblue--text"
  }, [_vm._v(" 온라인 면접 ")])])] : [_c('v-btn', {
    attrs: {
      "small": "",
      "width": "100",
      "color": "u-green-e7"
    }
  }, [_c('span', {
    staticClass: "u-green-5a--text"
  }, [_vm._v(" 오프라인 면접 ")])])]] : _vm._e(), _vm.value.isGranted === false ? [_c('body-refuse', _vm._b({
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "small": "",
            "width": "100",
            "color": "grey-ec"
          }
        }, 'v-btn', attrs, false), on), [_c('span', {
          staticClass: "grey--text"
        }, [_vm._v(" 면접 거부 ")])])];
      }
    }], null, false, 3422653554)
  }, 'body-refuse', {
    value: _vm.value
  }, false))] : _vm._e()], 2) : _c('div', [_vm.value.isGranted == null ? [_c('v-btn', {
    attrs: {
      "small": "",
      "width": "100",
      "color": "primary lighten-5"
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v(" 매칭대기 ")])])] : _vm._e(), _vm.value.isGranted == true ? [_c('v-btn', {
    attrs: {
      "small": "",
      "width": "100",
      "color": "secondary lighten-5"
    }
  }, [_c('span', {
    staticClass: "secondary--text"
  }, [_vm._v(" 매칭완료 ")])])] : _vm._e(), _vm.value.isGranted == false ? [_c('v-btn', {
    attrs: {
      "small": "",
      "width": "100",
      "color": "grey-ec"
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v(" 매칭실패 ")])])] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }